import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

import { TranslatePipe } from '@softline/ui-core';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-artstamm-detail-view',
  imports: [CommonModule,
    TranslatePipe],
  templateUrl: './artstamm.detail-view.html',
  styleUrls: ['./artstamm.detail-view.css'] })
export class ArtstammDetailView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
